import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { ProblemReframe } from './components/ProblemReframe';
import { MethodReveal } from './components/MethodReveal';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { Transformation } from './components/Transformation';
import { PricingCTA } from './components/PricingCTA';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-pink-100 selection:text-pink-900" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <ProblemReframe data-id="element-3" />
      <MethodReveal data-id="element-4" />
      <OldSolutionsFail data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <WhoItsFor data-id="element-7" />
      <Transformation data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}
export { App };